import { v4 as uuidv4 } from 'uuid';

import { ValidateFilenamesMutationVariables } from '../../graphql/generated';

export const getValidateFolderMutationInput = (
  cedantId: string,
  folderName: string
): ValidateFilenamesMutationVariables => ({
  cedant: cedantId,
  input: {
    files: [{ id: uuidv4(), filepath: folderName, isDirectory: true }],
  },
});
